module.exports = __webpack_public_path__ + "img/company-map.147832d2.png";